module.exports = __webpack_public_path__ + "img/icon1.796ce512.png";